import { useEffect } from "react";
import { createPortal } from "react-dom";
import CustomButton from "../components/custom-button";
import Loader from "../components/loader";
import { useSuretyModel } from "../store/use-surety-popup";

interface TPopupSuretyModel {
  loading?: boolean;
}

const PopupSuretyModel = ({ loading = false }: TPopupSuretyModel) => {
  const { onCloseSuretyPopup, initialValues } = useSuretyModel();

  useEffect(() => {
    const prev = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    const onKey = (e: KeyboardEvent) => {
      if (e.key === "Escape" && !loading) onCloseSuretyPopup();
    };
    window.addEventListener("keydown", onKey);
    return () => {
      document.body.style.overflow = prev;
      window.removeEventListener("keydown", onKey);
    };
  }, [loading, onCloseSuretyPopup]);

  return createPortal(
    <div
      className="z-[99999] w-screen h-screen fixed inset-0 bg-[color:var(--shadow-modal-scrim)] backdrop-blur-sm flex items-center justify-center animate-fade-in"
      onClick={() => !loading && onCloseSuretyPopup()}
    >
      <div
        className="bg-surface border border-edge shadow-overlay w-[min(92vw,460px)] rounded-2xl p-7 animate-fade-in"
        onClick={(e) => e.stopPropagation()}
      >
        <h2 className="text-[19px] font-bold text-heading-color leading-snug">
          {initialValues?.title || "Are you sure you wanna restart chase ?"}
        </h2>

        {initialValues?.description ? (
          <p className="mt-2.5 text-[13px] font-medium text-text-secondary leading-relaxed">
            {initialValues.description}
          </p>
        ) : null}

        <div className="flex items-center justify-end gap-2.5 mt-7">
          <CustomButton
            disabled={loading}
            className="bg-surface border border-edge hover:border-edge-strong cursor-pointer rounded-xl h-10 px-5 font-semibold !text-[14px] text-heading-color transition-colors duration-200"
            onClick={onCloseSuretyPopup}
          >
            Cancel
          </CustomButton>
          <CustomButton
            disabled={loading}
            className="bg-gradient-to-r from-accent to-accent-bright shadow-[0_8px_20px_-8px_rgba(99,102,241,0.7)] hover:-translate-y-px cursor-pointer rounded-xl h-10 px-5 font-semibold !text-[14px] text-white transition-all duration-200"
            onClick={initialValues.onClick}
          >
            {loading ? <Loader /> : initialValues?.confirmLabel || "Submit"}
          </CustomButton>
        </div>
      </div>
    </div>,
    document.body
  );
};

export default PopupSuretyModel;
